import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BLOCK_MODULE_NAMESPACE, BLOCK_SET_CURRENT_BLOCK_BY_ID } from '../../../store/block';
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)

@Component
class BlockApartments extends Vue {

  _clearTimeout: any;


  @BlockStore.Mutation(BLOCK_SET_CURRENT_BLOCK_BY_ID)
  storeSetBlockCurrentId: (id: string) => void;

  get blockId(): string {
    return this.$route.params.id;
  }

  mounted() {
    if (this.$route.params.id) {
      this.storeSetBlockCurrentId(this.$route.params.id);
    }
    this.$watch('$route.params', this.handleChangeBlockId);
  }
  handleChangeBlockId(newValue?: { id?: string, cid?: string }, oldVal?: { id?: string, cid?: string }) {
    if (newValue.id) {
      this.storeSetBlockCurrentId(newValue.id)
    }
  }
}

export default BlockApartments;


// WEBPACK FOOTER //
// ./src/containers/block/block-apartments/index.ts